import React from 'react'
import styled from 'styled-components'
import { Text } from 'rebass'
import { useLocation } from 'react-router-dom'

import ImgBox from '../../components/Gamification/ImgBox'
import ExchangeNft from '../../components/Gamification/ExchangeNft'
import { RowColumn } from '../../components/Row'

import { NFTTYPE } from '../../constants/bakery/nft'

const SoccerMain = styled.div`
  width: 890px;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width: 100%;
  `};
`
const Main = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`
const activeClassName = 'ACTIVENAV'

export const Info = styled.div`
    color: ${({ theme }) => theme.bsText7};
    width: 432px;
    height: 280px;
    overflow-y: scroll;
    padding: 16px 30px;
    border-radius: 20px;
    background: ${({ theme }) => theme.bsBg2};
    ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 90%;
    height: auto;
    margin: 0 auto;
    margin-bottom: 20px;
    `};
`


export default function Soccer () {
  const location = useLocation()
  return (
    <SoccerMain>
      <Main>
        <ImgBox imgLink={'/images/nft/doggies.png'}/>
        <RowColumn>
          <ExchangeNft type={NFTTYPE.DOGGIES} />
          <Info className={location.pathname.indexOf('gamification/car') > -1 ? activeClassName : ''}>
            <Text fontSize={18} fontFamily={'Baloo Da'} fontWeight={700}>How do Crypto Doggy NFTs work?</Text>
            <Text fontSize={14} marginTop={20}>1. Crypto Doggy are 10,000 unique and animated Doggy NFT, cryptographically generated using a series of different characteristics like Dog types, color scheme, eye blinking, and tongue stretch or accessories including glasses, scarf & hat. </Text>
            <Text fontSize={14} marginTop={20}>2. Each characteristic has a certain probability of occurrence, making some characteristics rarer than others, thus making some type of dogs very difficult to get.</Text>
            <Text fontSize={14} marginTop={20}>3. The Doggie NFT can only be purchased with $Doggy in Bakeryswap.org Gamification tab (The Doggy Shop) for 100,000 $DOGGY, or from another holder at the NFT Marketplace  (as a secondary market, where the price is decided by the owner). The NFT marketplace will only support $DOGGY payment.</Text>
            <Text fontSize={14} marginTop={20}>4. All the 100,000 $DOGGY spent in the Doggy Shop will be burned. $DOGGY has a total supply of 5 billion coins.Besides the collectible value of rare Doggy NFT, holders of the NFT can also benefit from staking benefits.</Text>
          </Info>
        </RowColumn>
      </Main>
    </SoccerMain>
  )
}